import BaseRangeDatepicker from 'components/atoms/base-range-datepicker';
import { endOfDate, startOfDate } from 'infrastructure/functions';
import { useTranslation } from 'react-i18next';
import { type FC } from 'react';

import s from './styles.module.scss';

import type {
  RangePickerValue,
  TOnCalendarChange,
} from 'components/atoms/base-range-datepicker';
import type {
  Filters,
  AppendFilters,
} from 'infrastructure/hooks/untrackedInboundCalls/types';

interface Props {
  filters: Filters;
  appendFilters: AppendFilters;
}

const DateRange: FC<Props> = ({ appendFilters, filters }) => {
  const changeTimeRange: TOnCalendarChange = (dates, _, info, preset) => {
    const [start, end] = dates;

    if (!start && !end) {
      appendFilters({
        startTime: undefined,
        endTime: undefined,
      });
      return;
    }

    if (preset && start && end) {
      appendFilters({
        startTime: startOfDate(start).toISOString(),
        endTime: endOfDate(end).toISOString(),
      });
      return;
    }

    if (start && info.range === 'start') {
      appendFilters({
        startTime: startOfDate(start).toISOString(),
      });
    }
    if (end && info.range === 'end') {
      appendFilters({
        endTime: endOfDate(end).toISOString(),
      });
    }
  };

  const selectedRange: RangePickerValue = [
    filters.startTime ? new Date(filters.startTime) : null,
    filters.endTime ? new Date(filters.endTime) : null,
  ];
  const { t } = useTranslation();

  return (
    <div style={{ width: '100%' }}>
      <div className={s['interaction-date-range']}>
        <label htmlFor="dateRange">{t('labels.disconnectTimeRange')}</label>
        <div className={s['input-wrapper']}>
          <BaseRangeDatepicker
            allowClear={false}
            withPresets
            onCalendarChange={changeTimeRange}
            value={selectedRange}
          />
        </div>
      </div>
    </div>
  );
};

export default DateRange;
